(function () {
  const ribbons = [
    { baseY: 50, amp: 30, peakWidth: 5,  opacity: 0.45, fMul: 0.65, f2Mul: 0.35, sMul:  1.0, drift: 0.4 },
    { baseY: 110, amp: 28, peakWidth: 5,  opacity: 0.45, fMul: 0.85, f2Mul: 0.55, sMul:  1.0, drift: 0.3 },
    { baseY: 220, amp: 36, peakWidth: 9,  opacity: 0.55, fMul: 1.15, f2Mul: 0.40, sMul: -0.7, drift: 1.6 },
    { baseY: 340, amp: 32, peakWidth: 7,  opacity: 0.50, fMul: 0.70, f2Mul: 0.65, sMul:  1.4, drift: 2.9 },
    { baseY: 460, amp: 40, peakWidth: 11, opacity: 0.40, fMul: 1.30, f2Mul: 0.45, sMul: -1.1, drift: 4.2 },
    { baseY: 560, amp: 30, peakWidth: 6,  opacity: 0.50, fMul: 0.95, f2Mul: 0.50, sMul:  0.8, drift: 5.5 },
  ];

  const SEGS = 36;
  const W = 1400;
  const SPEED = 0.05;
  const AMP_MULT = 2.55;
  const FREQ = 4;

  let ampScale = 1;
  let freqScale = 1;
  function recomputeScales() {
    const w = window.innerWidth;
    if (w <= 480) {
      ampScale = 0.45;
      freqScale = 0.7;
    } else if (w <= 767) {
      ampScale = 0.6;
      freqScale = 0.8;
    } else {
      ampScale = 1;
      freqScale = 1;
    }
  }
  recomputeScales();

  function ribbonPath(phase, r) {
    const localPhase = phase * r.sMul + r.drift;
    const ampJitter = 0.85 + Math.sin(phase * 0.3 + r.drift) * 0.15;
    const amp = r.amp * AMP_MULT * ampJitter * ampScale;
    const freq = FREQ * r.fMul * freqScale;
    const freq2 = FREQ * r.f2Mul * freqScale;
    const pts = new Array(SEGS + 1);
    for (let i = 0; i <= SEGS; i++) {
      const t = i / SEGS;
      const x = -60 + (W + 120) * t;
      const y = r.baseY
        + Math.sin(localPhase + t * freq) * amp
        + Math.sin(localPhase * 0.6 + t * freq2 + r.drift) * amp * 0.45;
      const widthMod = Math.sin(t * Math.PI) * (0.55 + 0.45 * Math.sin(localPhase * 0.7 + t * 3 + r.drift));
      const halfW = Math.max(0.3, r.peakWidth * widthMod);
      pts[i] = { x, y, halfW };
    }
    let d = 'M' + pts[0].x + ' ' + (pts[0].y - pts[0].halfW);
    for (let i = 1; i <= SEGS; i++) d += ' L' + pts[i].x + ' ' + (pts[i].y - pts[i].halfW);
    for (let i = SEGS; i >= 0; i--) d += ' L' + pts[i].x + ' ' + (pts[i].y + pts[i].halfW);
    return d + ' Z';
  }

  function init() {
    const host = document.querySelector('.hero__waves');
    if (!host) return;
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 1400 600');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const paths = ribbons.map((r) => {
      const p = document.createElementNS(NS, 'path');
      p.setAttribute('fill', '#fff');
      p.setAttribute('fill-opacity', String(r.opacity));
      svg.appendChild(p);
      return p;
    });
    host.appendChild(svg);

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      paths.forEach((p, i) => p.setAttribute('d', ribbonPath(0, ribbons[i])));
      return;
    }

    let phase = 0;
    let last = 0;
    let raf = 0;
    let visible = true;
    const obs = new IntersectionObserver(
      (entries) => { visible = entries[0].isIntersecting; },
      { threshold: 0 }
    );
    obs.observe(host);

    function tick(ts) {
      if (last && visible) {
        phase += ((ts - last) / 1000) * SPEED;
        for (let i = 0; i < paths.length; i++) {
          paths[i].setAttribute('d', ribbonPath(phase, ribbons[i]));
        }
      }
      last = ts;
      raf = requestAnimationFrame(tick);
    }
    raf = requestAnimationFrame(tick);

    window.addEventListener('resize', recomputeScales, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        cancelAnimationFrame(raf);
        last = 0;
      } else {
        raf = requestAnimationFrame(tick);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
